import { useTranslation } from 'react-i18next';
import PermissionsAwareFieldset from '../../../common/PermissionsAwareFieldset';
import OverallRating from '../../components/overallRating/OverallRating';
import { DirectBookingReviewsSectionContainer } from './DirectBookingReviews.styles';
import DirectBookingReviewsSectionHeader from './DirectBookingReviewsSectionHeader';
import DirectBookingReviewsTable from './DirectBookingReviewsTable';
import useDirectBookingRatingStats from './useDirectBookingRatingStats';

const DirectBookingReviewsSection = () => {
  const { t } = useTranslation();

  const { directBookingRatingStats, isLoading } = useDirectBookingRatingStats();

  return (
    <PermissionsAwareFieldset>
      <DirectBookingReviewsSectionContainer data-testid="direct-booking-reviews-section">
        <DirectBookingReviewsSectionHeader />
        <OverallRating
          title={t('pageProperty.reviews.directBooking.overallRating')}
          averageRating={directBookingRatingStats?.averageRating ?? 0}
          reviewsAmount={directBookingRatingStats?.totalReviewsCount ?? 0}
          isLoading={isLoading}
        />
        <DirectBookingReviewsTable />
      </DirectBookingReviewsSectionContainer>
    </PermissionsAwareFieldset>
  );
};

export default DirectBookingReviewsSection;
